class Customer.LoadingNoticeView extends Backbone.View
  template: JST['backbone/templates/customer/loading_notice']

  initialize: ->
    @loading = false

  render: ->
    @$el.html(@template())
    @$el.hide()
    @

  showLoading: ->
    @loading = true
    @$el.show()

  hideLoading: ->
    @loading = false
    @$el.hide()
